import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import CustomApplicationState from "@thos/Store/CustomApplicationState";

export const getRequestedDeliveryDateState = (state: ApplicationState) => {
    return state.pages.checkoutReviewAndSubmit.requestedDeliveryDate;
}

export const getThosSubmitForApprovalPONumber = (state : CustomApplicationState) =>{
    return state.ThosState.thosSubmitForApprovalState.poNumber;
}

export const getThosSubmitForApprovalPONumberError = (state : CustomApplicationState) =>{
    return state.ThosState.thosSubmitForApprovalState.poNumberError;
}